<div *ngFor="let address of addresses | addressType:allowedTypes"
     class="organization-address">
  <p>{{ address.address1 }}</p>
  <p>{{ address.address2 }}</p>
  <p>{{ address.address3 }}</p>
  <p>{{ address.address4 }}</p>
  <p>{{ address.townCity }} {{ address.zip }}</p>
  <p *ngIf="address.country?.name !== 'Not Applicable'">{{ address.country?.name }}</p>
</div>
